define('bindingHandlers/toggleClick',[
    'jquery',
    'lib/knockout'
], function ($, ko) {

    'use strict';

    /**
     * toggleClick Binding Handler (wrapper)
     *
     * Used to easily bind a click on an element to toggle the observable
     */

    ko.bindingHandlers.toggleClick = {
        init: function (element, valueAccessor) {
            var value = valueAccessor();

            $(element).on('click', function (event) {
                value(!value());
                event.preventDefault();
            });
        }
    };

});

